import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";
import { customAlphabet } from "nanoid";

export const nanoid = customAlphabet("1234567890ABCDEFGHJKLMNPRSTWXYZabcdefghjklmnprstwxyz", 10);

export function generateId(prefix?: string, length?: number) {
  return prefix ? `${prefix}-${nanoid(length || 10)}` : nanoid(length || 10);
}
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Debug helper - only log in development
export const debugLog = (message: string, ...args: any[]) => {
  if (import.meta.env.DEV) {
    console.log(message, ...args);
  }
};
